import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FromCreateModal from './from_create_modal'

export default class FromListNew extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showCreateModal: false
    }
  }

  showCreateModal() {
    this.setState({
      showCreateModal: true
    })
  }

  hideCreateModal() {
    this.setState({
      showCreateModal: false
    })
  }

  handleCreate(from) {
    const { onCreateFrom } = this.props

    this.hideCreateModal()
    onCreateFrom(from)
  }

  render() {
    const { showCreateModal } = this.state

    return (
      <div className="from-list-item middle">
        <div className="from-name">{I18n.t('components.mail_from.from_list_new.title')}</div>
        <div className="btn-group">
          <div className="btn-group-in">
            <button type="button" className="btn btn-primary" onClick={() => this.showCreateModal()}>
              {I18n.t('common.button.register')}
            </button>
          </div>
        </div>
        <FromCreateModal
          show={showCreateModal}
          onCancel={() => this.hideCreateModal()}
          onCreate={from => this.handleCreate(from)}
        />
      </div>
    )
  }
}

FromListNew.propTypes = {
  onCreateFrom: PropTypes.func.isRequired
}
